import React, { useState } from 'react';
import MetaTags from 'components/common/MetaTags';
import PageHeader from 'components/NewDesign/PageHeader';
import MainContent from 'components/NewDesign/MainContent';
import SeasonEventPerformance from 'components/admin/reports/SeasonEventPerformance';
import { exportSeasonEventPerformanceToFile } from 'api/reportsApi';
import { useSelector } from 'react-redux';
import CustomNewButton from 'components/NewDesign/CustomNewButton';
import { exportAndDownloadFile } from 'utils/fileDownload';

const SeasonEventPerformancePage = () => {
  const { selectedClub } = useSelector((state) => state.user || {});
  const [reportData, setReportData] = useState(null);

  const handleExportToFile = async () => {
    await exportAndDownloadFile(
      exportSeasonEventPerformanceToFile,
      [selectedClub.clubID],
      '',
      'The season event performance report was successfully exported',
      'Fetching season event performance data from the server...'
    );
  };

  const isExportButtonDisabled = !reportData || !reportData.hasData;

  return (
    <>
      <MetaTags title="SplitFast | Season Event Performance Report" />
      <MainContent>
        <PageHeader
          title="Season Event Performance"
          subTitle={reportData?.seasonName || ''}
          primarySubTitle
        >
          <CustomNewButton
            variant="info"
            onClick={handleExportToFile}
            label="Export to file"
            disabled={isExportButtonDisabled}
          />
        </PageHeader>
        {!selectedClub ? (
          <div style={{ minHeight: '100vh' }}/>
        ) : (
          <SeasonEventPerformance
            clubID={selectedClub?.clubID}
            onDataChange={setReportData}
          />
        )}
      </MainContent>
    </>
  );
};

export default SeasonEventPerformancePage;
